import { useUrlGenerator } from '@folklore/routes';
import React, { useContext, useMemo } from 'react';

import Api from '../lib/api/Api';

export const ApiContext = React.createContext(new Api());

export function useApi(): Api {
    const context = useContext(ApiContext);
    return context;
}

interface ApiContextProviderProps {
    client?: Api;
    children: React.ReactNode;
}

export function ApiContextProvider({ client, children }: ApiContextProviderProps) {
    const urlGenerator = useUrlGenerator();
    const api = useMemo(
        () =>
            client ||
            new Api({
                urlGenerator,
            }),
        [client, urlGenerator],
    );
    return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}
